/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ProductionPlannerRowDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns every non-archived work order for the partner with the project-planning grid shape (project / factory / product / container_selections / metadata) plus live tracking fields sourced from the base.schedules view (completed %, job-card progress, last-seen zone/station, drawings, actual start/complete timestamps).
 * @summary Production planner: partner-wide work orders with tracking fields
 */
export type productionPlannerControllerListPartnerProductionPlannerResponse200 = {
  data: ProductionPlannerRowDto[]
  status: 200
}

export type productionPlannerControllerListPartnerProductionPlannerResponse401 = {
  data: void
  status: 401
}

export type productionPlannerControllerListPartnerProductionPlannerResponse403 = {
  data: void
  status: 403
}
    
export type productionPlannerControllerListPartnerProductionPlannerResponseSuccess = (productionPlannerControllerListPartnerProductionPlannerResponse200) & {
  headers: Headers;
};
export type productionPlannerControllerListPartnerProductionPlannerResponseError = (productionPlannerControllerListPartnerProductionPlannerResponse401 | productionPlannerControllerListPartnerProductionPlannerResponse403) & {
  headers: Headers;
};

export type productionPlannerControllerListPartnerProductionPlannerResponse = (productionPlannerControllerListPartnerProductionPlannerResponseSuccess | productionPlannerControllerListPartnerProductionPlannerResponseError)

export const getProductionPlannerControllerListPartnerProductionPlannerUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/production-planner`
}

export const productionPlannerControllerListPartnerProductionPlanner = async (partnerId: string, options?: RequestInit): Promise<productionPlannerControllerListPartnerProductionPlannerResponse> => {
  
  return customFetch<productionPlannerControllerListPartnerProductionPlannerResponse>(getProductionPlannerControllerListPartnerProductionPlannerUrl(partnerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProductionPlannerControllerListPartnerProductionPlannerQueryKey = (partnerId?: string,) => {
    return [
    `/partners/${partnerId}/production-planner`
    ] as const;
    }

    
export const getProductionPlannerControllerListPartnerProductionPlannerQueryOptions = <TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlannerControllerListPartnerProductionPlannerQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>> = ({ signal }) => productionPlannerControllerListPartnerProductionPlanner(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductionPlannerControllerListPartnerProductionPlannerQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>>
export type ProductionPlannerControllerListPartnerProductionPlannerQueryError = void


export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>,
          TError,
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>,
          TError,
          Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Production planner: partner-wide work orders with tracking fields
 */

export function useProductionPlannerControllerListPartnerProductionPlanner<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductionPlannerControllerListPartnerProductionPlannerQueryOptions(partnerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Production planner: partner-wide work orders with tracking fields
 */
export const prefetchProductionPlannerControllerListPartnerProductionPlannerQuery = async <TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 queryClient: QueryClient, partnerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProductionPlannerControllerListPartnerProductionPlannerQueryOptions(partnerId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProductionPlannerControllerListPartnerProductionPlannerQueryKey(partnerId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>> = ({ signal }) => productionPlannerControllerListPartnerProductionPlanner(partnerId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>>
export type ProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryError = void


export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Production planner: partner-wide work orders with tracking fields
 */

export function useProductionPlannerControllerListPartnerProductionPlannerSuspense<TData = Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError = void>(
 partnerId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof productionPlannerControllerListPartnerProductionPlanner>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProductionPlannerControllerListPartnerProductionPlannerSuspenseQueryOptions(partnerId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




